import React, { useEffect, useState } from 'react';

import { Image, ImageProps } from './Image';

interface ImageWithFallbackProps extends ImageProps {
  fallbackSrc: string;
}

export const ImageWithFallback = ({
  fallbackSrc,
  src,
  ...rest
}: ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => setImgSrc(src), [src]);

  return (
    <Image {...rest} onError={() => setImgSrc(fallbackSrc)} src={imgSrc} />
  );
};
